import { useCallback } from 'react';
import { captureEvent } from '../../lib/analytics';
import { ModalType, DetectionFeedbackData } from './types-constants';

export function useDetectionFeedbackModal(
  openModal: (type: ModalType, data?: Record<string, unknown>) => void
) {
  const triggerDetectionFeedback = useCallback(
    (data: DetectionFeedbackData) => {
      openModal(ModalType.DETECTION_FEEDBACK, data);

      captureEvent('Safety_DetectionFeedbackPromptShown', {
        moderation_event_id: data.moderationEventId,
        severity: data.severity || 'medium',
        matched_pattern_ids: data.matchedPatternIds || [],
        matched_semantic_categories: data.matchedSemanticCategories || [],
        pattern_count: data.matchedPatternIds?.length || 0,
      });
    },
    [openModal]
  );

  return {
    triggerDetectionFeedback,
  };
}
